
import Util from 'service/util'

const MessageCustomerVehicleServiceTable = ({
  service
}) =>
{
  if (!service)
  {
    return <div>沒有服務紀錄。</div>
  }

  const lockey = `${service.srv_dis}${service.srv_loc}`

  return (
    <table>
      <tbody>
        <tr>
          <th>地點</th>
          <td>{ lockey } - { Util.getLocationName(lockey) }</td>
        </tr>
        <tr>
          <th>計劃</th>
          <td>{ service.srv_plan }</td>
        </tr>
        <tr>
          <th>工日</th>
          <td>{ [service.weekday1, service.weekday2, service.weekday3].map(Util.WeekdayName).filter(x => x).join('') }</td>
        </tr>
        <tr>
          <th>價錢</th>
          <td>{ service.fee } + { service.extra_fee }</td>
        </tr>
      </tbody>
    </table>
  )
}

const MessageCustomerVehicle = ({
  cd_license, activeService
}) =>
{
  return (
    <div className="message-customer-vehicle">
      <div className="box">
        <div className="box-head">
          <strong className="license">{ cd_license }</strong>
        </div>
        <div className="box-body">
          <MessageCustomerVehicleServiceTable service={activeService} />
        </div>
      </div>
    </div>
  )
}

export default MessageCustomerVehicle
